export const getErrorMessage = ({ status, apiErrorMessage, fetchType }) => {
  if (status && status.toString().charAt(0) === '4') {
    switch (fetchType) {
      case 'product':
        return {
          message: 'Product not found.',
        };
      case 'brand-update':
        return {
          message: 'Brand update failed.',
          remedy: apiErrorMessage || 'Unable to update brand, please try again later.',
        };
      case 'brand-delete':
        return {
          message: 'Could not delete brand.',
          remedy: 'Please try again later. If the problem persists, please get in touch.',
        };
      case 'update-product':
        return {
          message: 'Product update failed.',
          remedy: apiErrorMessage || 'Unable to update product, please try again later.',
        };
      case 'product-search':
        return {
          message: 'Product search failed.',
          remedy: 'Unable to run search, please try again later.',
        };
      case 'bulk-update-product':
        return {
          message: 'Bulk product update failed.',
          remedy: 'Unable to update products. Please check sheet and columns are named correctly.',
        };
      case 'bulk-download-product':
        return {
          message: 'Bulk product download failed.',
          remedy: 'Unable to download products, please try again later.',
        };
      case 'location':
        return {
          message: 'Location not found.',
          remedy: 'Please check you have entered a valid URL.',
        };
      case 'events':
        if (status.toString() === '404') {
          return {
            message: apiErrorMessage || 'Could not retrieve events.',
            remedy: 'If the problem persists, please get in touch.',
          };
        }
        break;
      case 'event':
        if (status.toString() === '404') {
          return {
            message: 'Event not found.',
            remedy: 'If the problem persists, please get in touch.',
          };
        }
        break;
      case 'navigation':
        if (status.toString() === '404') {
          return {
            message: apiErrorMessage || 'Could not find category.',
            remedy: 'Something went wrong, use your browser back button to go back',
          };
        }
        break;
      case 'hierarchy':
        return {
          message: apiErrorMessage || 'Could not load hierarchy.',
          remedy: 'Please try again later. If the problem persists, please get in touch.',
        };
      case 'category':
        if (status.toString() === '404') {
          return {
            message: apiErrorMessage || 'Could not find category.',
          };
        }
        break;
      default:
        if (fetchType && status.toString() === '404') {
          return {
            message: `Could not find ${fetchType}.`,
            remedy: 'Please check you have entered a valid search value.',
          };
        }
    }
  }

  const message =
    fetchType === 'bulk-update'
      ? 'Bulk update failed'
      : 'Sorry, there seems to be a problem. Please try again.';
  return {
    message,
    remedy: apiErrorMessage || 'If the problem persists, please get in touch.',
  };
};

export const getAbortErrorData = ({ fetchType, params }) => {
  if (params && params.method === 'DELETE') {
    if (['links', 'icons', 'messages', 'terms-and-conditions'].includes(fetchType)) {
      return {
        message: 'Timed out trying to delete content',
        remedy:
          'This will continue to run in the background - please check whether the item has been deleted from the content screen in a few minutes.',
      };
    }
  }

  return {
    message: 'Request timed out.',
    remedy:
      'Please check your network connection and try again. If the problem persists please get in touch.',
  };
};

export const sendErrorToNewRelic = (error, customData) => {
  if (window.newrelic) {
    window.newrelic.noticeError(error, customData);
  }
};
